import React from 'react';

interface Props {
  name: string;
  size?: number;
  style?: Record<string, any>;
  color?: string;
  title?: string;
}

export const Icon = (props: Props) => {
  const { name, size, style, color, title } = props;
  const iconStyle = {
    fontSize: size,
    color,
    ...style,
  };
  return <i className={name} style={iconStyle} title={title} />;
};
